import { put, takeLatest } from "redux-saga/effects";

import { EToastType } from "@/components/common/AlertToast/AlertToast.types";
import apiErrorHandler from "@/utils/apiErrorHandler";
import {
  GET_TECHNOLOGIES_API_HTTP_STATUS_CODES,
  GET_TECHNOLOGIES_ERROR_MESSAGE,
} from "@/constants/CodingConstants";
import { HTTP_STATUS_CODES } from "@/constants/HttpConstants";
import { showToast } from "../actions/appStatus.action";
import { getTechnologiesAPI } from "../api/codeEditor.api";
import { GET_TECHNOLOGIES } from "../constants/ActionTypes";
import { call } from "./utils.saga";

function* getTechnologies() {
  try {
    const getTechnologiesResp = yield* call(getTechnologiesAPI);
    if (getTechnologiesResp.status === HTTP_STATUS_CODES.OK) {
      yield put({
        type: `${GET_TECHNOLOGIES}_SUCCESS`,
        payload: {
          technologies: getTechnologiesResp.data.technologies,
        },
      });
    }
  } catch (error: unknown) {
    const message = yield* call(
      apiErrorHandler,
      error,
      GET_TECHNOLOGIES_API_HTTP_STATUS_CODES,
      GET_TECHNOLOGIES_ERROR_MESSAGE,
    );
    if (message)
      yield put(
        showToast({
          message,
          type: EToastType.ERROR,
        }),
      );
  }
}

export default function* loadCodeEditorSaga() {
  yield takeLatest(GET_TECHNOLOGIES, getTechnologies);
}
